import * as Types from './mutationsType'

export default {
    // 设置应用角色
    [Types.APPID] (state, payload) {
        state.appId = payload
    },
    // 是否为系统管理员
    [Types.IS_ADMIN] (state, payload) {
        state.isAdmin = payload
    },
    // routeName
    [Types.ROUTE_NAME] (state, payload) {
        state.curRouteName = payload
    },
    // appflag
    [Types.APP_HANDLE_FLAG] (state, payload) {
        state.appFlag = state.appFlag + payload
    }
}